import axios from 'axios';

import RequestHeadersBase from '~/common/constants/RequestHeadersBase';
import { handleRefreshInterceptor } from '~/services/interceptors/handle-refresh.interceptor';
import { setAuthTokenInterceptor } from '~/services/interceptors/set-auth-token.interceptor';

export const promoCodeService = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_API_URL_SPLASH}marketing-service/api/promo-codes`,
  headers: {
    ...RequestHeadersBase,
    'splash-accept-version': '2',
  },
});

setAuthTokenInterceptor(promoCodeService);
handleRefreshInterceptor(promoCodeService);
